import { render, staticRenderFns } from "./Figure.vue?vue&type=template&id=0cf31b3d&scoped=true"
import script from "./Figure.vue?vue&type=script&lang=js"
export * from "./Figure.vue?vue&type=script&lang=js"
import style1 from "./Figure.vue?vue&type=style&index=1&id=0cf31b3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf31b3d",
  null
  
)

export default component.exports